module.exports = __webpack_public_path__ + "static/logo-dark-b9f9b9b8fd96cba157eb38528ad730ed.png";